import { Injectable, QueryList } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AssistantService } from './assistant.service';
import { AssistantBehaviourEvent } from '../models/assistant/assistant.behaviour.event';
import { AssistantStatusEvent } from '../models/assistant/assistant.status.event';

@Injectable({
  providedIn: 'root',
})
export class AssistantPopoverService {
  private subscriptionsOnPopoverShownEvent: Subscription[] = [];
  private lastAssistantStatusEvent: AssistantStatusEvent;

  constructor(public assistantService: AssistantService) {}

  /**
   * Initialisiert den AssistantService und setzt notwendige Subscriptions.
   * @param assistantPopoverList Liste der NgbPopovers
   */
  initializeAssistant(assistantPopoverList: QueryList<NgbPopover>) {
    if (this.assistantService) {
      this.assistantService.assistantStatusUpdate$.subscribe((event: AssistantStatusEvent) => {
        if (event) {
          this.assistantService.handleAssistantStatusEventForComponent(event, assistantPopoverList);
          this.lastAssistantStatusEvent = { ...event, assistantPopoverListChanged: true };
        }
      });

      this.assistantService.assistantBehaviourUpdate$.subscribe((event: AssistantBehaviourEvent) => {
        if (event) {
          this.assistantService.handleAssistantBehaviourEventForComponent(event, assistantPopoverList);
        }
      });
    }

    this.subscribeToPopoverShownEvent(assistantPopoverList);

    assistantPopoverList.changes.subscribe((popoverQueryList: QueryList<NgbPopover>) => {
      if (this.lastAssistantStatusEvent) {
        this.assistantService.handleAssistantStatusEventForComponent(this.lastAssistantStatusEvent, popoverQueryList);
      }
      this.subscribeToPopoverShownEvent(popoverQueryList);
    });
  }

  /**
   * Fügt Subscriptions hinzu, um beim Öffnen eines Popovers alle anderen zu schließen.
   * @param popoverList Liste der Popovers
   */
  private subscribeToPopoverShownEvent(popoverList: QueryList<NgbPopover>) {
    this.subscriptionsOnPopoverShownEvent.forEach(sub => sub.unsubscribe());
    this.subscriptionsOnPopoverShownEvent = popoverList.map(popover =>
      popover.shown.subscribe(() => this.assistantService.closeOthers(popover))
    );
  }

  /**
   * Deaktiviert den Assistenten.
   */
  disableAssistant() {
    this.assistantService.disable();
  }
}
